import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";
import relativeTime from "dayjs/plugin/relativeTime";

import timezone from "dayjs/plugin/timezone";
import UTC from "dayjs/plugin/utc";

dayjs.extend(isToday);
dayjs.extend(isYesterday);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(UTC);

/**
 * Timezone-aware check if a date is today.
 */
function isTodayTz(date: string, tz: string): boolean {
  const today = dayjs().tz(tz).startOf("day");
  return dayjs(date).tz(tz).startOf("day").isSame(today, "day");
}

/**
 * Timezone-aware check if a date is yesterday.
 */
function isYesterdayTz(date: string, tz: string): boolean {
  const yesterday = dayjs().tz(tz).subtract(1, "day").startOf("day");
  return dayjs(date).tz(tz).startOf("day").isSame(yesterday, "day");
}

/**
 * Timezone-aware check if a date is tomorrow.
 */
function isTomorrowTz(date: string, tz: string): boolean {
  const tomorrow = dayjs().tz(tz).add(1, "day").startOf("day");
  return dayjs(date).tz(tz).startOf("day").isSame(tomorrow, "day");
}

/**
 * Returns a date group label ("Today", "Yesterday", "Tomorrow", or the given
 * format) based on timezone. Default fallback format is "DD MMM YYYY".
 */
function getDateLabel(date: string, tz: string, format = "DD MMM YYYY"): string {
  if (isTodayTz(date, tz)) return "Today";
  if (isYesterdayTz(date, tz)) return "Yesterday";
  if (isTomorrowTz(date, tz)) return "Tomorrow";
  return dayjs(date).tz(tz).format(format);
}

export { dayjs, isTodayTz, isYesterdayTz, isTomorrowTz, getDateLabel };
